<app-nav></app-nav>
<div class="container">
  <div class="page-header">
    <h1>Edit Newsletter </h1>
    <p class="lead">Drag and drop </p>
    <div style="text-align: right;">
      <!-- <button (click)="send()" >Send</button> -->
    </div>

    <form name="form" (ngSubmit) = "send()" id="loginform" novalidate #f = "ngForm">
      <mat-form-field style="width:100%">
        <mat-label>Enter the email id of the doctor</mat-label>
        <input matInput type="email_list" name="email_list" placeholder="Enter the email id of the doctor" [(ngModel)]="this.email_list" #email="ngModel" required autofocus id="uemail" required>
      </mat-form-field>
      <div class="flex flex-row">
        <div class="flex-[1_1_100%] flex flex-col justify-center items-end">
          <button mat-raised-button type="submit" id="submit" color="primary">Submit</button>
          <!-- <i class="fa fa-spinner fa-spin"  *ngIf="load"></i> -->
        </div>
      </div>
    </form>

  </div>
  <div class="row">
    <button mat-raised-button (click)="getdatafeature()" color="primary">Feature</button>
    <!-- <button mat-raised-button (click)="getdatacolumn()" color="primary">Column</button>
    <button mat-raised-button (click)="getdataguidelines()" color="primary">Guidelines</button>
    <button mat-raised-button (click)="getdatasurvey()" color="primary">Survey</button> -->
  </div>




  <div class="row" id="newsletters">
    <div class="col-md-6"><h3>Metrics Article of Doctor</h3> </div>
    <div class="col-md-6"><h3>List of Articles</h3> </div>
    <div class="col-md-6"
      cdkDropList
      #newsletterListDrop="cdkDropList"
      [cdkDropListData]="newsletter_list"
      [cdkDropListConnectedTo]="[modelListDrop]"
      (cdkDropListDropped)="drop($event)">
      @for (item of newsletter_list; track item) {
        <div
          class="col-md-12"
          cdkDrag>{{item.headline}}<br>{{item.sub_headline}}</div>
        }
      </div>

      <div class="col-md-6"
        cdkDropList
        #modelListDrop="cdkDropList"
        [cdkDropListData]="model"
        [cdkDropListConnectedTo]="[newsletterListDrop]"
        (cdkDropListDropped)="drop($event)">
        @for (item of model; track item) {
          <div
            class="col-md-12"
            cdkDrag>{{item.headline}} <br>{{item.sub_headline}}</div>
          }
        </div>
      </div>

    </div>
